import { VariantProps, cva } from 'class-variance-authority';
import { DetailedHTMLProps, ForwardedRef, LiHTMLAttributes, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

const listItemVariants = cva(['flex items-center gap-2 text-sm font-medium px-4 py-2 outline-none'], {
    variants: {
        active: {
            true: 'bg-primary/5 dark:bg-primary/10 text-primary',
            false: '',
        },
        hover: {
            true: 'cursor-pointer transition-colors duration-200 hover:bg-primary/5',
            false: '',
        },
        disabled: {
            true: 'opacity-50 cursor-not-allowed hover:bg-transparent',
            false: '',
        },
    },
    defaultVariants: {
        active: false,
        hover: true,
        disabled: false,
    },
});

interface ListItemProps
    extends DetailedHTMLProps<LiHTMLAttributes<HTMLLIElement>, HTMLLIElement>,
        VariantProps<typeof listItemVariants> {
    ref?: ForwardedRef<HTMLLIElement>;
}

const ListItem = forwardRef<HTMLLIElement, ListItemProps>((props, ref) => {
    const { children, active, hover, disabled, className, ...rest } = props;

    return (
        <li {...rest} ref={ref} className={twMerge(listItemVariants({ active, hover, disabled, className }))}>
            {children}
        </li>
    );
});

export default ListItem;
